// utils/storageService.ts

export const storageService = {
    getItem<T>(key: string): T | null {
      const data = localStorage.getItem(key);
      if (!data) return null;
      try {
        return JSON.parse(data) as T;
      } catch (error) {
        console.error(`Error parsing localStorage data for key "${key}"`, error);
        return null;
      }
    },
  
    setItem<T>(key: string, value: T): void {
      localStorage.setItem(key, JSON.stringify(value));
    },
  
    removeItem(key: string): void {
      localStorage.removeItem(key);
    },
  
    clear(): void {
      localStorage.clear();
    },
  };
  